<template>
  <div>
    <v-container fluid v-if="!vistaRapida">
      <v-row align="start" justify="center">
        <v-col lg="4" sm="12" xs="12" style="min-width: 300px;padding: 5px 5px 0px 5px;" cols="12">
          <v-row lg="10" sm="12" md="12" style="padding: 5px;margin-left: 10px;" v-if="$route.path == '/individualFuel'">
            <p style="font-weight: bold;cursor:auto !important;" v-if="nick == '' || movilId == ''" >{{$t("noVehicle").toUpperCase()}}</p>
            <p style="font-weight: bold;cursor:auto !important;" v-else>{{nick}} ({{movilId}})</p>
          </v-row>
          <v-col lg="10" sm="12" md="12" style="padding: 5px;">
            <v-autocomplete
              :items="dealers"
              item-text="Name"
              item-value="DealerId"
              v-model="dealerSelected"
              :search-input.sync="searchDealer"
              :label="$t('dealer')"
              outlined
              :color="colorTheme"
              :disabled="dealersDisabled"
              clearable
              class="dealer" 
              :attach="this.$store.state.dealerAttach"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t("noResults") }} : "{{
                      searchDealer
                      }}".
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col lg="10" sm="12" md="12" style="padding: 5px;">
            <v-autocomplete
              :items="clients"
              item-text="Name"
              item-value="ClientId"
              v-model="clientSelected"
              :search-input.sync="searchClient"
              :label="$t('client')"
              outlined
              :color="colorTheme"
              :disabled="clientsDisabled"
              clearable
              class="client" 
              :attach="this.$store.state.clientAttach"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t("noResults") }} : "{{
                      searchClient
                      }}".
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col lg="10" sm="12" md="12" style="padding: 5px;">
            <v-autocomplete
              :items="accounts"
              item-text="Name"
              item-value="AccountId"
              v-model="accountSelected"
              :search-input.sync="searchAccount"
              :label="$t('account')"
              outlined
              :color="colorTheme"
              :disabled="accountsDisabled"
              clearable
              class="account" 
              :attach="this.$store.state.accountAttach"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t("noResults") }} : "{{
                      searchAccount
                      }}".
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col lg="10" sm="12" md="12" style="padding: 5px">
            <v-autocomplete
              :items="groups"
              item-text="Name"
              item-value="GroupId"
              v-model="groupSelected"
              :search-input.sync="searchGroup"
              :label="$t('group')"
              outlined
              :color="colorTheme"
              :disabled="groupsDisabled"
              clearable
              class="group" 
              :attach="this.$store.state.groupAttach"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t("noResults") }} : "{{
                      searchGroup
                      }}".
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col lg="10" sm="12" md="12" style="padding: 0px;">
              <v-btn v-on:click="updateFilter()">
                {{ $t("update") }}
              </v-btn>
          </v-col>
        </v-col>

        <v-col lg="4" sm="12" style="text-align: initial;" cols="12">
          <v-text-field
            v-if="this.$store.state.windowSize.width <= 1263"
            append-icon="mdi-magnify"
            solo
            v-model="searchList"
            clearable
            @click:clear="clearSearch"
            single-line
            :placeholder="$t('search')"
          ></v-text-field>
          <v-card>
            <v-toolbar flat class="elevation-0">
              <v-icon :color="colorTheme" style="padding-right: 8px;">mdi-truck</v-icon>
              <v-toolbar-title :style="titleListV" v-if="$route.path == '/individualFuel'">
                {{ $t("available") }}
                {{ ": " + this.$store.state.listVehiclesAF.length }}
              </v-toolbar-title>
              <v-toolbar-title :style="titleListV" v-else>
                {{ $t("available") }}
                {{ ": " + vehicles.length }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-if="this.$store.state.windowSize.width > 1263"
                flat
                append-icon="mdi-magnify"
                solo
                v-model="searchList"
                clearable
                @click:clear="clearSearch"
                single-line
                style="padding-top: 33px;"
              ></v-text-field>
            </v-toolbar>
            <!-- <v-list
              id="infinite-list"
              two-line
              flat
              max-height="70%"
              style="max-height: 70%;overflow-y: scroll;height: 301px;max-width: 100%;"
            >
              <v-divider></v-divider>
              <v-progress-linear
                indeterminate
                :color="colorTheme"
                height="2"
                v-show="progressFilter"
              ></v-progress-linear>
              <v-list-item-group>
                <v-divider></v-divider>
                <v-list-item v-if="vehiclesList.length == 0">
                  <v-list-item-content v-if="searchList.length == 0">
                    <v-list-item-title v-if="progressFilter">{{
                      $t("loadingTable")
                    }}</v-list-item-title>
                    <v-list-item-title v-else>{{
                      $t("noResults")
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content v-else>
                    <v-list-item-title
                      >{{ $t("noResults") }} : "{{
                        searchList
                      }}".</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <template v-else v-for="(item, index) in vehiclesList">
                  <v-list-item
                    :key="item.title"
                    v-on:mouseover="selectItem(item)"
                    v-on:mouseleave="unSelectItem()"
                  >
                    <v-list-item-content>
                      <v-list-item-title v-text="item.Nick"></v-list-item-title>
                      <v-list-item-subtitle
                        v-text="item.MovilId"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon
                        v-if="item.active && starVisible"
                        :color="colorTheme"
                        >mdi-star</v-icon
                      >
                    </v-list-item-action>
                    <v-list-item-action>
                      <v-menu bottom left style="z-index: 15;">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-show="(item === selectedItem || visible == false) && starVisible"
                            :color="colorTheme"
                            icon
                            text
                            v-on="on"
                          >
                            <v-icon>mdi-dots-horizontal</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item-title v-if="visibleoption">
                            <v-btn
                              text
                              small
                              :color="colorTheme"
                              v-on:click="addVehicle(item)"
                              >{{ $t("addToList") }}</v-btn
                            >
                          </v-list-item-title>
                          <v-list-item-title v-else>
                            <v-btn
                              text
                              small
                              :color="colorTheme"
                              v-on:click="deletVehicle(item)"
                              >{{ $t("deleteVehicle") }}</v-btn
                            >
                          </v-list-item-title>
                        </v-list>
                      </v-menu>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    v-if="index + 1 < vehicles.length"
                    :key="index"
                  ></v-divider>
                </template>
              </v-list-item-group>
            </v-list>-->
            <v-divider></v-divider>
            <v-container v-if="$route.path == '/individualFuel'">
              <v-data-table
                :headers="headers"
                :items="this.$store.state.listVehiclesAF"
                item-key="MovilId"
                :loading="progressFilter"
                :loading-text="$t('loadingTextForTable')"
                class="elevation-0"
                :no-data-text="$t('noResults')"
                :items-per-page="5"
                :footer-props="{
                  'items-per-page-text': $t('rows'),
                  'items-per-page-all-text': $t('all'),
                }"
                mobile-breakpoint="0"
                :search="searchList"
                single-select
                show-select
                v-model="selectedCheckbox"
              >
              <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t("of").toLowerCase()}} {{ items.itemsLength }} </template>
              </v-data-table>
            </v-container>
            <v-container v-else>
              <v-data-table
              :headers="headerFVTable"
              :items="this.$store.state.vehicles"
              :loading="progressFilter"
              :loading-text="$t('loadingTextForTable')"
              hide-default-header
              class="elevation-0"
              :no-data-text="$t('noResults')"
              :items-per-page="5"
              :footer-props="{
                'items-per-page-text': $t('rows'),
                'items-per-page-all-text': $t('all'),
              }"
              mobile-breakpoint="0"
              :search="searchList"
            >
              <template v-slot:item.MovilIdAndNick="{ item }">
                <td
                  v-on:mouseover="selectItem(item)"
                  v-on:mouseleave="unSelectItem()"
                >{{item.MovilIdAndNick}}</td>
              </template>
              <template v-slot:item.actions="{ item }">
                <td
                  v-on:mouseover="selectItem(item)"
                  v-on:mouseleave="unSelectItem()"
                >
                  <v-icon
                      v-if="item.active && starVisible && $route.path != '/tracking' && $route.path != '/home'"
                      :color="colorTheme"
                    >mdi-star</v-icon>
                    <v-menu
                      v-if="$route.path != '/tracking' && $route.path != '/home'"
                      bottom
                      left
                      style="z-index: 15"
                    >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-show="
                          (item === selectedItem || visible == false) &&
                          starVisible
                        "
                        :color="colorTheme"
                        icon
                        text
                        v-on="on"
                      >
                        <v-icon>mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item-title v-if="visibleoption">
                        <v-btn
                          text
                          small
                          :color="colorTheme"
                          v-on:click="addVehicle(item)"
                        >{{ $t("addToList") }}</v-btn>
                      </v-list-item-title>
                      <v-list-item-title v-else>
                        <v-btn
                          text
                          small
                          :color="colorTheme"
                          v-on:click="deletVehicle(item)"
                        >{{ $t("deleteVehicle") }}</v-btn>
                      </v-list-item-title>
                    </v-list>
                  </v-menu>
                </td>
              </template>
              <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t("of").toLowerCase()}} {{ items.itemsLength }} </template>
            </v-data-table>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else style="min-height: 450px;">
      <v-row align="start" justify="space-around">
        <v-col lg="6" sm="12" style="text-align: initial;" cols="12">
          <v-text-field
            v-if="this.$store.state.windowSize.width <= 1263"
            :placeholder="$t('search')"
            append-icon="mdi-magnify"
            solo
            v-model="search"
            clearable
            @click:clear="clearQuickSearch"
            single-line
          ></v-text-field>
          <v-card>
            <v-toolbar flat class="elevation-0">
              <v-btn icon text small :color="colorTheme" v-on:click="changeTable(false)">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <v-toolbar-title :style="titleListV">
                {{ $t("available") }}
                {{ ": " + vehiclesAggregates.length }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-if="this.$store.state.windowSize.width > 1263"
                flat
                append-icon="mdi-magnify"
                solo
                v-model="search"
                clearable
                @click:clear="clearQuickSearch"
                single-line
                style="padding-top: 33px;"
              ></v-text-field>
            </v-toolbar>
            <!-- <v-list
              two-line
              flat
              max-height="70%"
              style="max-height: 70%;overflow-y: scroll;height: 301px;max-width: 100%;"
            >
              <v-divider></v-divider>
              <v-list-item-group>
                <v-divider></v-divider>
                <v-list-item v-if="vehiclesQuickList.length == 0">
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ $t("noResults") }} : "{{
                        search
                      }}".</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <template v-else v-for="(item, index) in vehiclesQuickList">
                  <v-list-item :key="item.title">
                    <v-list-item-content>
                      <v-list-item-title v-text="item.Nick"></v-list-item-title>
                      <v-list-item-subtitle
                        v-text="item.MovilId"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn
                        text
                        small
                        :color="colorTheme"
                        v-on:click="deletVehicle(item)"
                      >
                        <v-icon>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    v-if="index + 1 < vehiclesAggregates.length"
                    :key="index"
                  ></v-divider>
                </template>
              </v-list-item-group>
            </v-list>-->
            <v-divider></v-divider>
            <v-data-table
              :headers="headerFVTable"
              :items="this.$store.state.vehiclesAggregates"
              hide-default-header
              class="elevation-0"
              :no-data-text="$t('noResults')"
              :items-per-page="5"
              :footer-props="{
                'items-per-page-text': $t('rows'),
                'items-per-page-all-text': $t('all'),
              }"
              mobile-breakpoint="0"
              :search="search"
            >
              <template v-slot:item.actions="{ item }">
                <td>
                  <v-btn text small :color="colorTheme" v-on:click="deletVehicle(item)">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </td>
              </template>
              <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t("of").toLowerCase()}} {{ items.itemsLength }} </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";

export default {
  name: "filterVehicles",
  data: () => ({
    snackbar: false,
    mode: "",
    timeout: 6000,
    y: "top",
    x: null,
    search: "",
    all: "",
    style:
      "width: 0; margin-left: 5px; transition: all .5s; min-width: 0px; display: -webkit-inline-box; padding-right: 6%;",
    solo: false,
    icon: "mdi-magnify",
    selectedItem: false,
    visibleoption: true,
    searchList: "",
    searchDealer: "",
    searchClient: "",
    searchAccount: "",
    searchGroup: "",
    headers: [
        { text: "Nick", value: "Nick" },
        { text: "Movil ID", value: "MovilId" }
      ],
    selectedCheckbox: [],
    nick: "",
    movilId: ""
  }),
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.$store.commit("setValuesReportsPage");
    this.$store.dispatch("getCatalog");
  },
  mounted() {
    // const listElm = document.querySelector("#infinite-list");
    // listElm.addEventListener("scroll", (e) => {
    //   if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
    //     this.$store.commit("showMoreVehicles");
    //     // console.log("S C R O L L");
    //   }
    // });
  },
  watch: {
    selectedCheckbox() {
        var vehSelected = this.selectedCheckbox;
        if (vehSelected.length != 0) {
          this.movilId = vehSelected[0].MovilId;
          this.nick = vehSelected[0].Nick;
          this.$store.state.disableFV = false;
        } else {
          this.$store.state.disableFV = true;
        }
        this.$store.state.vehicleSelectedAF = vehSelected[0];
    },
    vehiclesAggregates() {
      if (this.vehiclesAggregates.length == 0) {
        this.$store.commit("checkFastList", false);
        this.$store.commit("changeTable", false);
      }
    },
    vehicles() {
      // this.vehiclesListItems = [];
      // this.showMoreVehicles();
    }
  },
  computed: {
    ...mapState([
      "headersFilterV",
      "vehicles",
      "dealers",
      "clients",
      "accounts",
      "groups",
      "dealersDisabled",
      "clientsDisabled",
      "accountsDisabled",
      "groupsDisabled",
      "progress",
      "colorTheme",
      "styleFV",
      "progressFilter",
      "visible",
      "vistaRapida",
      "vehiclesAggregates",
      "titleListV",
      "vehiclesListItems",
      "headerFVTable",
      "setVehicles",
      "listVehiclesAF",
    ]),
    dealerSelected: {
      get: function() {
        return this.$store.state.dealerSelected;
      },
      set: function(val) {
        this.movilId = '';
        this.nick = '';
        if (val != undefined) {
          if (val != this.$t("all")) {
            var delaerselected = this.$store.getters.getAccessFilter([
              this.$store.state.dealers,
              val,
              "DealerId"
            ]);

            console.log(delaerselected);
            this.$store.commit("filterSelected", [
              delaerselected,
              this.$t("all"),
              this.$t("all"),
              this.$t("all")
            ]);
            this.$store.dispatch("getFilterAccountCatalog", [
              "clients?DealerId=" + val,
              "Dealer"
            ]);
            this.$store.commit("deletAllVehicles");
          } else {
            this.$store.commit("filterSelected", [
              val,
              this.$t("all"),
              this.$t("all"),
              this.$t("all")
            ]);
            this.$store.commit("deletAllVehicles");
          }
        } else {
          this.$store.commit("filterSelected", [
            val,
            this.$t("all"),
            this.$t("all"),
            this.$t("all")
          ]);
          this.$store.commit("filtersEnabled", [false, true, true, true]);
          this.$store.commit("deletAllVehicles");
        }
      }
    },
    clientSelected: {
      get: function() {
        return this.$store.state.clientSelected;
      },
      set: function(val) {
        this.movilId = '';
        this.nick = '';
        if (val != undefined) {
          if (val != this.$t("all")) {
            var clientselected = this.$store.getters.getAccessFilter([
              this.$store.state.clients,
              val,
              "ClientId"
            ]);
            this.$store.commit("filterSelected", [
              this.$store.state.dealerSelected,
              clientselected,
              this.$t("all"),
              this.$t("all")
            ]);
            this.$store.dispatch("getFilterAccountCatalog", [
              "accounts?DealerId=" +
                this.$store.state.dealerSelected.DealerId +
                "&ClientId=" +
                val,
              "Client"
            ]);

            this.$store.commit("deletAllVehicles");
          } else {
            this.$store.dispatch("getVehiclesCatalog", [
              "&did=" + this.$store.state.dealerSelected.DealerId,
              false
            ]);
            this.$store.commit("filterSelected", [
              this.$store.state.dealerSelected,
              val,
              this.$t("all"),
              this.$t("all")
            ]);
            this.$store.commit("deletAllVehicles");
          }
        } else {
          this.$store.commit("filterSelected", [
            this.$store.state.dealerSelected,
            val,
            this.$t("all"),
            this.$t("all")
          ]);
          this.$store.commit("filtersEnabled", [false, false, true, true]);
          this.$store.commit("deletAllVehicles");
        }
      }
    },
    accountSelected: {
      get: function(val) {
        return this.$store.state.accountSelected;
      },
      set: function(val) {
        this.movilId = '';
        this.nick = '';
        if (val != undefined) {
          if (val != this.$t("all")) {
            var accountselected = this.$store.getters.getAccessFilter([
              this.$store.state.accounts,
              val,
              "AccountId"
            ]);
            this.$store.commit("filterSelected", [
              this.$store.state.dealerSelected,
              this.$store.state.clientSelected,
              accountselected,
              this.$t("all")
            ]);
            this.$store.dispatch("getFilterAccountCatalog", [
              "vehiclegroups?DealerId=" +
                this.$store.state.dealerSelected.DealerId +
                "&ClientId=" +
                this.$store.state.clientSelected.ClientId +
                "&AccountId=" +
                val,
              "Account"
            ]);
            this.$store.commit("deletAllVehicles");
          } else {
            this.$store.dispatch("getVehiclesCatalog", [
              "&did=" +
                this.$store.state.dealerSelected.DealerId +
                "&cid=" +
                this.$store.state.clientSelected.ClientId,
              false
            ]);
            this.$store.commit("filterSelected", [
              this.$store.state.dealerSelected,
              this.$store.state.clientSelected,
              val,
              this.$t("all")
            ]);
            this.$store.commit("deletAllVehicles");
          }
        } else {
          this.$store.commit("filterSelected", [
            this.$store.state.dealerSelected,
            this.$store.state.clientSelected,
            val,
            this.$t("all")
          ]);
          this.$store.commit("filtersEnabled", [false, false, false, true]);
          this.$store.commit("deletAllVehicles");
        }
      }
    },
    groupSelected: {
      get: function() {
        return this.$store.state.groupSelected;
      },
      set: function(val) {
        this.movilId = '';
        this.nick = '';
        if (val != undefined) {
          if (val != this.$t("all")) {
            var groupselected = this.$store.getters.getAccessFilter([
              this.$store.state.groups,
              val,
              "GroupId"
            ]);
            this.$store.commit("filterSelected", [
              this.$store.state.dealerSelected,
              this.$store.state.clientSelected,
              this.$store.state.accountSelected,
              groupselected
            ]);
            this.$store.dispatch("getVehiclesCatalog", [
              "&did=" +
                this.$store.state.dealerSelected.DealerId +
                "&cid=" +
                this.$store.state.clientSelected.ClientId +
                "&acid=" +
                this.$store.state.accountSelected.AccountId +
                "&gpid=" +
                val,
              false
            ]);
            this.$store.commit("deletAllVehicles");
          } else {
            this.$store.dispatch("getVehiclesCatalog", [
              "&did=" +
                this.$store.state.dealerSelected.DealerId +
                "&cid=" +
                this.$store.state.clientSelected.ClientId +
                "&acid=" +
                this.$store.state.accountSelected.AccountId,
              false
            ]);
            this.$store.commit("filterSelected", [
              this.$store.state.dealerSelected,
              this.$store.state.clientSelected,
              this.$store.state.accountSelected,
              val
            ]);
            this.$store.commit("deletAllVehicles");
          }
        } else {
          this.$store.commit("filterSelected", [
            this.$store.state.dealerSelected,
            this.$store.state.clientSelected,
            this.$store.state.accountSelected,
            val
          ]);
          this.$store.commit("deletAllVehicles");
        }
      }
    },
    // vehiclesList: function() {
    //   if (!this.searchList) {
    //     return _.orderBy(this.$store.state.vehiclesListItems, "MovilId");
    //   } else if (this.searchList) {
    //     return _.orderBy(
    //       this.$store.state.vehicles.filter((item) => {
    //         return (
    //           item.Nick.toLowerCase().includes(this.searchList.toLowerCase()) ||
    //           item.MovilId.toLowerCase().includes(this.searchList.toLowerCase())
    //         );
    //       }),
    //       "MovilId"
    //     );
    //   }
    // },
    vehiclesQuickList: function() {
      return _.orderBy(
        this.$store.state.vehiclesAggregates.filter(item => {
          if (!this.search) return this.$store.state.vehiclesAggregates;
          return (
            item.Nick.toLowerCase().includes(this.search.toLowerCase()) ||
            item.MovilId.toLowerCase().includes(this.search.toLowerCase())
          );
        }),
        "MovilId"
      );
    },
    starVisible: function() {
      if (
        this.$route.path == "/reportsPage/stepper" ||
        this.$store.state.initialSettings
      )
        return false;
      else return true;
    }
  },
  methods: {
    clearSearch() {
      this.searchList = "";
    },
    clearQuickSearch() {
      this.search = "";
    },
    changeTable: function(val) {
      this.$store.commit("changeTable", val);
    },
    selectItem(item) {
      if (this.$route.path != "/reportsPage/stepper") {
        this.selectedItem = item;
        this.visibleoption = this.$store.getters.funcionprovisional(item);
      }
    },
    unSelectItem() {
      this.selectedItem = false;
    },
    addVehicle(val) {
      this.$store.commit("vehiclesAggregates", val);
    },
    deletVehicle(val) {
      this.$store.commit("deletVehicles", val);
    },
    textfieldstyle() {
      if (this.icon == "mdi-magnify") {
        this.style =
          "width: 50%; margin-left: 5px; transition: all .5s; min-width: 300px; display: -webkit-inline-box;";
        this.icon = "mdi-close";
        this.solo = true;
      } else {
        this.style =
          "width: 0%; margin-left: 5px; transition: all .5s; min-width: 0px; display: -webkit-inline-box; padding-right: 11%;padding-top: 0!important;";
        this.icon = "mdi-magnify";
        this.solo = false;
      }
    },
    getByLevel: async function(level) {
      if (this.$store.state.SelectedAccess.Level != "Master") {
        this.$store.commit("filterSelected", [
          this.$t("all"),
          this.$t("all"),
          this.$t("all"),
          this.$t("all")
        ]);
      }
    },
    updateFilter() {
      this.$store.dispatch("updateGetCatalog");
    }
  }
};
</script>

<style>
.v-menu__content {
  text-align: initial;
}
</style>
